import SvgIcon from "./SvgIcon";

export default function HikeIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M1.008 6.682h3.946a2.669 2.669 0 002.36-1.418L8.63 2.791c.1-.192.265-.188.364 0l3.746 7.045a1.57 1.57 0 002.77 0l1.305-2.455a1.322 1.322 0 011.169-.7h5.008V5.33h-5.008a2.666 2.666 0 00-2.36 1.418L14.318 9.2c-.107.2-.28.2-.386 0l-3.746-7.042a1.556 1.556 0 00-2.748 0L6.124 4.629a1.324 1.324 0 01-1.17.7H1.008v1.353z"
        fill={color}
      />
      <path
        d="M23.257 11.33H18.19a2.688 2.688 0 00-2.38 1.43l-1.321 2.484c-.112.21-.291.214-.405 0l-3.79-7.127a1.566 1.566 0 00-2.766 0l-1.33 2.5a1.345 1.345 0 01-1.19.715H1.017v1.35H5.01a2.692 2.692 0 002.38-1.431l1.33-2.5c.108-.2.276-.2.384 0l3.79 7.127a1.58 1.58 0 002.788 0L17 13.4a1.346 1.346 0 011.189-.716h5.067V11.33z"
        fill={color}
      />
      <path
        d="M15.81 18.76l-1.321 2.484c-.112.21-.291.214-.405 0l-3.79-7.127a1.565 1.565 0 00-2.766 0l-1.33 2.5a1.345 1.345 0 01-1.19.715H1.017v1.35H5.01a2.692 2.692 0 002.38-1.431l1.33-2.5c.108-.2.276-.2.384 0l3.79 7.127a1.58 1.58 0 002.788 0L17 19.4a1.346 1.346 0 011.189-.716h5.067V17.33H18.19a2.688 2.688 0 00-2.38 1.43z"
        fill={color}
      />
    </SvgIcon>
  )
}
